import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsFoundationFrameIP, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';

@Component({
  selector: 'ds-foundation-frame',
  templateUrl: './ds-foundation-frame.component.html',
  styleUrls: ['./ds-foundation-frame.component.css']
})
export class DsFoundationFrameComponent implements OnInit, OnChanges {
  
    @Input() dsFoundationFrameObj: DsFoundationFrameIP;
    @Input() soLockObtained:boolean;
    @Input() accessLevel: Array<UserType>;
    @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();
    
    disableForm: boolean = false;
    inputDisableMessage: string = 'This form is not yet enabled';
    readonlyAccess : boolean = false;
    Hvr:any = {};
    hasAccessEE: boolean = false;
    hasAccessME: boolean = false;
    hasAccessPM: boolean = false;
    lockFields: boolean = false; // After HOM lock
  
    constructor(public _dataService: DataService, public dialog: MatDialog) { }
  
    ngOnInit(): void {
    }
    ngOnChanges(): void {
       this.disableForm = true;
      if(this.soLockObtained == false){
        this.inputDisableMessage = "You can't Edit";
      }
      else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
      else {
        this.disableForm = false;
        // this.checkUserEnabled();
      }
      if(this._dataService.hasReadOnlyAccess){
        this.readonlyAccess = true;
      }
      this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
      if (!this.dsFoundationFrameObj.parentSORef.isDatasheetSubOrderEnabled) {
        this.lockFields = false;
      }
      else {
        this.lockFields = true;
      }
  
    }
   
  sectionNoteChangePM(_event: any) {
    this.dsFoundationFrameObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsFoundationFrameObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsFoundationFrameObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection:boolean){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, 
            (_submitToNextSection == true ? SaveEventType.Submit_To_Next:SaveEventType.Save_Data)));
      }
    }
    reloadData(){
      if(this.updateDatasheet){
        this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
      }
    }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessME) {
      _validList.push(
        new ValidationItem("Foundation Frame ISMC 75", !!this.dsFoundationFrameObj.ffrISMC, " required to save Datasheet.")
      );
      if (this.dsFoundationFrameObj.isffrCoatingApplicable) {
        _validList.push(new ValidationItem("Coating", !!this.dsFoundationFrameObj.ffrCoating, " required to save Datasheet."));
      }
      _validList.push(new ValidationItem("ME Note", !!this.dsFoundationFrameObj.sectionNoteME, " required to save Datasheet."));
    }
    if (this.hasAccessEE) {
      _validList.push(new ValidationItem("EE Note", !!this.dsFoundationFrameObj.sectionNoteEE, " required to save Datasheet."));
    }
    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsFoundationFrameObj.sectionNotePM, " required to save Datasheet."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessME) {
      if (!this.dsFoundationFrameObj.ffrISMC || !this.dsFoundationFrameObj.sectionNoteME) return false;
      if (this.dsFoundationFrameObj.isffrCoatingApplicable && !this.dsFoundationFrameObj.ffrCoating) return false;
    }
    if (this.hasAccessEE) {
      if (!this.dsFoundationFrameObj.sectionNoteEE) return false;
    }
    if (this.hasAccessPM) {
      if (!this.dsFoundationFrameObj.sectionNotePM) return false;
    }
    return true;
  }
}

